export const userTypes = {
    contact: 1,
    customerUser: 2,
    employeeUser: 3
};

export const eventOriginEnum = {
    Unknown: 1,
    ManualImport: 2,
    Email: 3,
    Api: 4,
    CustomerCreated: 5
}

export const eventOrigins = [
    { "id": 1, "name": "Unknown" },
    { "id": 2, "name": "Manual Import" },
    { "id": 3, "name": "Email" },
    { "id": 4, "name": "Api"},
    { "id": 5, "name": "Customer Created"}
]

export const codingEventPriorityEnum = {
    low: 1,
    medium: 2,
    high: 3,
    Urgent: 4
}

export const codingEventPriorities = [
    { "id": 1, "name": "Low" },
    { "id": 2, "name": "Medium" },
    { "id": 3, "name": "High" },
    { "id": 4, "name": "Urgent" },
]